import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import PricingCard from 'molecules/PricingCard/PricingCard';
import React from 'react';
import { IPricingCard } from 'src/hooks/usePricingCards';

export interface PricingCardListProps {
  pricingCards: IPricingCard[];
  priceBlockMinHeight?: number;
  totalColumns?: {
    default: number;
    xl: number;
    sm: number;
  };
}

const PricingCardList = ({
  pricingCards,
  priceBlockMinHeight,
  totalColumns = { default: 4, xl: 2, sm: 1 },
}: PricingCardListProps): JSX.Element => {
  return (
    <Grid
      gap='spacing-4xl'
      gapSm='spacing-xl'
      maxWidthXl='width-xl'
      marginTopSm='spacing-4xl'
      totalColumns={totalColumns.default}
      totalColumnsXl={totalColumns.xl}
      totalColumnsSm={totalColumns.sm}
    >
      {pricingCards.map((pricingCard, index) => (
        <Stack key={index}>
          <PricingCard
            {...pricingCard}
            priceBlockMinHeight={priceBlockMinHeight}
          />
        </Stack>
      ))}
    </Grid>
  );
};

export default PricingCardList;
